<div class="mp-app" #ionApp>
    <router-outlet *ngIf="!isNewHomePedirDelivery"></router-outlet>
    <router-outlet *ngIf="isNewHomePedirDelivery"></router-outlet>
    <app-modal-outlet *ngIf="isNewHomePedirDelivery"></app-modal-outlet>

    <!--
      A ÚNICA tela deste template que não depende do roteador.

      Todo o resto aqui é outlet: se a navegação de entrada não chega, o outlet
      fica vazio, o spinner já saiu e o cliente olha branco puro. Este bloco é o
      que ele vê no lugar. Ligado por `bootSemTela`, que só vira `true` quando o
      roteador confirma que NENHUMA navegação completou (ver
      `verificarSeEntregouTela`).

      Sem `translate`: as traduções vêm por HTTP e este bloco existe justamente
      para o boot que não completou — o pipe devolveria a chave crua na tela.
      Texto literal é a única coisa que sobrevive aqui.
    -->
    <div class="boot-sem-tela" *ngIf="bootSemTela" role="alert">
        <div class="boot-sem-tela__caixa">
            <h1 class="boot-sem-tela__titulo">Não conseguimos abrir o cardápio</h1>
            <p class="boot-sem-tela__texto">
                A conexão demorou demais para responder. Verifique sua internet e tente de novo.
            </p>
            <button type="button" class="boot-sem-tela__botao" (click)="recarregarPorGesto()">
                Tentar de novo
            </button>
        </div>
    </div>
</div>
